import type {Endpoints} from "@hosttools/web/server/routes/routes-accounts.types";

import {sanitizeAccount} from "../../models/account";
import {Base} from "../base";

class channelService extends Base<Endpoints> {
    async fetchAccounts(isDemo?: boolean) {
        const data = await this.get("/accounts", undefined, {
            demo: isDemo ? "true" : undefined
        });
        return data.map(sanitizeAccount);
    }
}

export default channelService;
